"use client";

// src/components/default/circle-check.tsx
import * as React from "react";
import { useUID } from "@stepstone-genesis/uid-library";
import { systemForwardRef } from "@stepstone-genesis/system";
import {
  IconContainer
} from "@stepstone-genesis/icon-containers";
var CircleCheckIcon = systemForwardRef(
  function IconWrapper({ title, id, display, size, color, ...rest }, ref) {
    const identifier = useUID();
    const titleId = title ? `CircleCheckIcon-${id != null ? id : identifier}` : void 0;
    const role = title ? "img" : "presentation";
    const componentName = `CircleCheckIcon`;
    return /* @__PURE__ */ React.createElement(
      IconContainer,
      {
        ...rest,
        display,
        size,
        color,
        ref
      },
      /* @__PURE__ */ React.createElement(
        "svg",
        {
          "data-genesis-element": componentName,
          role,
          width: "100%",
          height: "100%",
          viewBox: "0 0 20 20",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          "aria-labelledby": titleId
        },
        title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
        /* @__PURE__ */ React.createElement(
          "path",
          {
            fill: "currentColor",
            d: "M8.9213 11.1635L7.52705 9.79014C7.41167 9.67476 7.28748 9.61573 7.15446 9.61306C7.02145 9.61038 6.89458 9.66941 6.77386 9.79014C6.65314 9.91087 6.59277 10.0399 6.59277 10.1771C6.59277 10.3144 6.65314 10.4434 6.77386 10.5641L8.45655 12.2468C8.5933 12.3836 8.74821 12.452 8.9213 12.452C9.09436 12.452 9.24927 12.3836 9.38602 12.2468L13.2097 8.42312C13.3251 8.30775 13.3842 8.18008 13.3868 8.04012C13.3895 7.90016 13.3305 7.76982 13.2097 7.6491C13.089 7.52838 12.9635 7.46802 12.8331 7.46802C12.7028 7.46802 12.5773 7.52838 12.4566 7.6491L8.9213 11.1635ZM10.0012 17.5834C8.96182 17.5834 7.98124 17.386 7.05946 16.9913C6.13767 16.5966 5.33085 16.0534 4.639 15.3619C3.94714 14.6704 3.40376 13.8639 3.00886 12.9426C2.61396 12.0212 2.4165 11.0408 2.4165 10.0015C2.4165 8.94818 2.61387 7.96412 3.00859 7.04929C3.40331 6.13444 3.94643 5.3311 4.63796 4.63925C5.3295 3.94739 6.13596 3.40401 7.05732 3.0091C7.97866 2.6142 8.95903 2.41675 9.99842 2.41675C11.0517 2.41675 12.0358 2.61411 12.9506 3.00883C13.8654 3.40355 14.6688 3.94668 15.3606 4.63821C16.0525 5.32975 16.5959 6.13273 16.9908 7.04714C17.3857 7.96155 17.5831 8.94539 17.5831 9.99867C17.5831 11.0381 17.3858 12.0186 16.991 12.9404C16.5963 13.8622 16.0532 14.669 15.3617 15.3609C14.6701 16.0527 13.8671 16.5961 12.9527 16.991C12.0383 17.3859 11.0545 17.5834 10.0012 17.5834ZM9.99982 16.5001C11.8054 16.5001 13.3401 15.8681 14.604 14.6042C15.8679 13.3403 16.4998 11.8056 16.4998 10.0001C16.4998 8.19451 15.8679 6.65978 14.604 5.39589C13.3401 4.13201 11.8054 3.50006 9.99982 3.50006C8.19426 3.50006 6.65954 4.13201 5.39565 5.39589C4.13176 6.65978 3.49982 8.19451 3.49982 10.0001C3.49982 11.8056 4.13176 13.3403 5.39565 14.6042C6.65954 15.8681 8.19426 16.5001 9.99982 16.5001Z"
          }
        )
      )
    );
  }
);
export {
  CircleCheckIcon
};
